export const loginEn = {
  adminLogin: "Admin Login",
  teacherLogin: "Teacher Login", 
  parentLogin: "Parent Login",
  adminTitle: "Educational System",
  adminSubtitle: "Administrator Login",
  associationName: "Al-Falah Association",
  adminWarning: "This area is restricted to administrators only. Please verify your identity before proceeding.",
  adminWelcome: "Welcome to the Administrators Platform - Comprehensive Educational System Management",
  adminPlatform: "Administrators Platform",
  adminDescription: "Comprehensive management of all aspects of the educational system and performance tracking",
  adminServices: "Services available for administrators:",
  adminService1: "Student and teacher management",
  adminService2: "Grades and assessments management",
  adminService3: "Communication and reports management",
  adminService4: "System settings and statistics",
  teacherTitle: "Educational System",
  teacherSubtitle: "Teacher Login",
  teacherWelcome: "Welcome to the Teachers Platform - Manage and track your students' Quran memorization",
  teacherPlatform: "Teachers Platform",
  teacherDescription: "Manage and track your students in Quran memorization and evaluate their performance",
  teacherServices: "Services available for teachers:",
  teacherService1: "Record memorization tracking",
  teacherService2: "Record grades and assessments",
  teacherService3: "Communication with parents",
  teacherService4: "View reports and statistics",
  parentTitle: "Educational System",
  parentSubtitle: "Parent Login",
  parentWelcome: "Welcome to the Parent Platform - Track your children's progress in Quran memorization",
  parentPlatform: "Parent Platform",
  parentDescription: "Track your children's progress in Quran memorization and their academic performance",
  parentServices: "Services available for parents:",
  parentService1: "Track student progress in memorization",
  parentService2: "View grades and assessments",
  parentService3: "Communicate with teachers",
  parentService4: "Receive monthly reports", 
  email: "Email Address",
  username: "Username",
  password: "Password",
  rememberMe: "Remember me",
  forgotPassword: "Forgot password?",
  login: "Login",
  loading: "Logging in...",
  noAccount: "No account? Create new account",
  backHome: "Back to homepage",
  adminRequest: "Request admin privileges",
  enterUsername: "Enter username",
  enterPassword: "Enter password",
  fillAllFields: "Please fill all fields",
  loginError: "Login error",
  connectionError: "Server connection error",
  enterUsernamePassword: "Please enter username and password",
  serverError: "An error occurred while verifying data",
  maintenanceTitle: "Site Under Construction",
  maintenanceMessage: "We are currently working on developing and improving the site. It will be launched soon, Insha'Allah",
  forStaffAndAdmins: "For Staff and Administrators",
  forStaffAndAdminsOnly: "For Staff and Administrators Only",
  resetSession: "Reset Session",
  noAccess: "You do not have permission to access this page. User type",
  unknown: "Unknown",
  or: "or",
  forgotPasswordDescription: "Enter your email, username, or phone number to resend your login credentials",
  optional: "optional",
  enterEmail: "Enter email address",
  enterPhone: "Enter phone number",
  phone: "Phone number",
  cancel: "Cancel",
  send: "Send",
  forgotPasswordError: "Please enter at least one of the following: email, username, or phone number",
  forgotPasswordSuccess: "Login credentials have been sent to your email"
};

